import { Link } from 'react-router-dom';
import '../styles/components/Footer.css';

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-grid">
        <section className="footer-brand">
          <h3>Psiholog Novi Sad – Clarity Psihološko Savetovalište</h3>
        </section>

        <section>
          <h4>Stranice</h4>
          <ul>
            <li><Link to="/usluge">Usluge</Link></li>
            <li><Link to="/za-kompanije">Za Kompanije</Link></li>
            <li><Link to="/cenovnik">Cenovnik</Link></li>
            <li><Link to="/kontakt">Kontakt</Link></li>
          </ul>
        </section>

        <section>
          <h4>Kontakt</h4>
          <ul>
            <li><a href="mailto:clarity.psiholog@gmail.com">clarity.psiholog@gmail.com</a></li>
            <li><a href="tel:+381603898789">+381 60 389 8789</a></li>
            <li>Novi Sad, Serbia</li>
            <li>
              <a
                href="https://www.linkedin.com/company/psiholo%C5%A1ki-centar-clarity/"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
                aria-label="Clarity na LinkedIn-u"
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                </svg>
                LinkedIn
              </a>
            </li>
          </ul>
        </section>
      </div>

      <div className="legal">
        © {new Date().getFullYear()} <a href="https://escr.online/" target="_blank" rel="noopener noreferrer">ESCR LLC</a> • All rights reserved
        {' '}• <Link to="/politika-privatnosti">Politika privatnosti</Link>
      </div>
    </footer>
  );
}
